import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/bloqueio-agenda-profissional`;

export const bloquear = async (agenda) => {
  return await axios.post(`${httpUrl}/bloquear-agenda`, agenda).then((response) => response);
};

export const listarBloqueios = async (cpf) => {
  return await axios.get(`${httpUrl}/list/cpf/${cpf}`).then((response) => response);
};

export const desabilitar = async (id) => {
  return await axios.post(`${httpUrl}/desabilitar/${id}`).then((response) => response);
};
